module.exports = __webpack_public_path__ + "fonts/memQYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWq8tWZ0Pw86hd0RkyFjWV4ewJER.1b15c76.woff2";